import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/views/index/index"),
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: () => import("@/views/privacy/index"),
    },
    {
      path: "/agreement",
      name: "Agreement",
      component: () => import("@/views/agreement/index"),
    },
    {
      path: "/contact",
      name: "Contact",
      component: () => import("@/views/contact/index"),
    },
  ],
});
